import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { partners } from '../mock';

export const PartnersCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const partnersPerView = 4; // Anzahl der sichtbaren Partner

  const nextSlide = () => {
    setCurrentIndex((prev) => 
      prev + partnersPerView >= partners.length ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? Math.max(0, partners.length - partnersPerView) : prev - 1
    );
  };

  const visiblePartners = partners.slice(currentIndex, currentIndex + partnersPerView);
  
  // Wenn weniger als partnersPerView sichtbar sind, fülle vom Anfang auf
  if (visiblePartners.length < partnersPerView) {
    const remaining = partnersPerView - visiblePartners.length;
    visiblePartners.push(...partners.slice(0, remaining));
  }

  return (
    <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 sm:p-12">
      <div className="text-center mb-10">
        <h3 className="text-3xl sm:text-4xl font-bold text-black mb-4">Unsere starken Partner</h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Wir arbeiten mit den führenden Marken der Baubranche zusammen
        </p>
      </div>

      {/* Carousel */}
      <div className="relative">
        <div className="overflow-hidden">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {visiblePartners.map((partner, index) => (
              <div
                key={`${currentIndex}-${index}`}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center h-32 animate-in fade-in duration-500"
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 sm:-translate-x-12 w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center hover:bg-black hover:border-black hover:text-white transition-all duration-300 shadow-lg group"
          aria-label="Vorherige Partner"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 sm:translate-x-12 w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center hover:bg-black hover:border-black hover:text-white transition-all duration-300 shadow-lg group"
          aria-label="Nächste Partner"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      {/* Dots Indicators */}
      <div className="flex justify-center gap-2 mt-8">
        {Array.from({ length: Math.ceil(partners.length / partnersPerView) }).map((_, index) => (
          <button
            key={`partner-group-${index}`}
            onClick={() => setCurrentIndex(index * partnersPerView)}
            className={`transition-all duration-300 rounded-full ${
              Math.floor(currentIndex / partnersPerView) === index
                ? 'w-8 h-2 bg-black'
                : 'w-2 h-2 bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Partner Gruppe ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};